/**
 * @fileoverview gRPC-Web generated client stub for qowner.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: projects/erp/service/api/v1/services/chat_gpt_configurations.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

var projects_erp_service_api_v1_model_chat_gpt_configuration_pb = require('./chat_gpt_configuration_pb.js')
const proto = {};
proto.qowner = {};
proto.qowner.erp = {};
proto.qowner.erp.api = {};
proto.qowner.erp.api.v1 = {};
proto.qowner.erp.api.v1.services = require('./chat_gpt_configurations_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.ChatGptConfigurationClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.ChatGptConfigurationPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.ListChatGptConfigurationsRequest,
 *   !proto.qowner.erp.api.v1.services.ListChatGptConfigurationsResponse>}
 */
const methodDescriptor_ChatGptConfiguration_ListChatGptConfigurations = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.ChatGptConfiguration/ListChatGptConfigurations',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.ListChatGptConfigurationsRequest,
  proto.qowner.erp.api.v1.services.ListChatGptConfigurationsResponse,
  /**
   * @param {!proto.qowner.erp.api.v1.services.ListChatGptConfigurationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.qowner.erp.api.v1.services.ListChatGptConfigurationsResponse.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.ListChatGptConfigurationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.services.ListChatGptConfigurationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.services.ListChatGptConfigurationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.ChatGptConfigurationClient.prototype.listChatGptConfigurations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.ChatGptConfiguration/ListChatGptConfigurations',
      request,
      metadata || {},
      methodDescriptor_ChatGptConfiguration_ListChatGptConfigurations,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.ListChatGptConfigurationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.services.ListChatGptConfigurationsResponse>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.ChatGptConfigurationPromiseClient.prototype.listChatGptConfigurations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.ChatGptConfiguration/ListChatGptConfigurations',
      request,
      metadata || {},
      methodDescriptor_ChatGptConfiguration_ListChatGptConfigurations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.GetChatGptConfigurationRequest,
 *   !proto.qowner.erp.api.v1.model.ChatGptConfiguration>}
 */
const methodDescriptor_ChatGptConfiguration_GetChatGptConfiguration = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.ChatGptConfiguration/GetChatGptConfiguration',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.GetChatGptConfigurationRequest,
  projects_erp_service_api_v1_model_chat_gpt_configuration_pb.ChatGptConfiguration,
  /**
   * @param {!proto.qowner.erp.api.v1.services.GetChatGptConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_chat_gpt_configuration_pb.ChatGptConfiguration.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.GetChatGptConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.model.ChatGptConfiguration)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.model.ChatGptConfiguration>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.ChatGptConfigurationClient.prototype.getChatGptConfiguration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.ChatGptConfiguration/GetChatGptConfiguration',
      request,
      metadata || {},
      methodDescriptor_ChatGptConfiguration_GetChatGptConfiguration,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.GetChatGptConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.model.ChatGptConfiguration>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.ChatGptConfigurationPromiseClient.prototype.getChatGptConfiguration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.ChatGptConfiguration/GetChatGptConfiguration',
      request,
      metadata || {},
      methodDescriptor_ChatGptConfiguration_GetChatGptConfiguration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.ApplyChatGptConfigurationRequest,
 *   !proto.qowner.erp.api.v1.model.ChatGptConfiguration>}
 */
const methodDescriptor_ChatGptConfiguration_ApplyChatGptConfiguration = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.ChatGptConfiguration/ApplyChatGptConfiguration',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.ApplyChatGptConfigurationRequest,
  projects_erp_service_api_v1_model_chat_gpt_configuration_pb.ChatGptConfiguration,
  /**
   * @param {!proto.qowner.erp.api.v1.services.ApplyChatGptConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_chat_gpt_configuration_pb.ChatGptConfiguration.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.ApplyChatGptConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.model.ChatGptConfiguration)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.model.ChatGptConfiguration>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.ChatGptConfigurationClient.prototype.applyChatGptConfiguration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.ChatGptConfiguration/ApplyChatGptConfiguration',
      request,
      metadata || {},
      methodDescriptor_ChatGptConfiguration_ApplyChatGptConfiguration,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.ApplyChatGptConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.model.ChatGptConfiguration>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.ChatGptConfigurationPromiseClient.prototype.applyChatGptConfiguration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.ChatGptConfiguration/ApplyChatGptConfiguration',
      request,
      metadata || {},
      methodDescriptor_ChatGptConfiguration_ApplyChatGptConfiguration);
};


module.exports = proto.qowner.erp.api.v1.services;

